import {
  PaginationTableSettings,
  SortableTableSettings,
} from '@@/datatables/types';

export interface GitCredentialTableSettings
  extends SortableTableSettings,
    PaginationTableSettings {}

export enum AuthTypeOption {
  Basic = 0,
  Token = 1,
}

export enum Provider {
  Custom = 0,
  GitHub = 1,
  GitLab = 2,
  BitbucketCloud = 3,
  BitbucketDataCenter = 4,
  AzureDevOps = 5,
  GiteaForgejo = 6,
}

export interface GitCredentialFormValues {
  name: string;
  username?: string;
  password: string;
  provider: Provider;
  authorizationType: AuthTypeOption;
}

export interface UpdateGitCredentialPayload {
  name: string;
  username?: string;
  password: string;
  provider: Provider;
  authorizationType: AuthTypeOption;
}

export type GitCredential = {
  id: number;
  userId: number;
  name: string;
  username: string;
  creationDate: number;
  provider: Provider;
  authorizationType: AuthTypeOption;
};
